//Generated File 
export default class ApplicationVersion{
	static readonly BUILD_DAY = 29;
	static readonly BUILD_HOUR = 15;
	static readonly BUILD_MINUTE = 42;
	static readonly BUILD_MONTH = 9;
	static readonly BUILD_YEAR = 2026;
	static readonly DATABASE_VERSION = 156;
	static readonly SERVER_VERSION = 7;
}
